(function () {
  "use strict";

  /*
    SPARC CONFIGURATOR METRIC MOTION V1.5

    PRICE ARCHITECTURE
    - Watches the actual price value for DOM mutations.
    - MutationObserver runs before browser paint, so the first changed price
      can be covered immediately by the previous stable price.
    - Waits for rapid Hulk/configurator intermediate values to settle.
    - Runs a mechanical cash-register roll from OLD -> FINAL only.
    - Animation lives in a separate layer attached to the metric card.
    - The true price element is never resized, overflow-clipped, or rebuilt.

    PRODUCTION ARCHITECTURE
    - Keeps the premium illuminated-breath animation.
  */

  if (window.__SPARC_CONFIGURATOR_METRIC_MOTION_V1_5__) return;
  window.__SPARC_CONFIGURATOR_METRIC_MOTION_V1_5__ = true;

  var PANEL_IDS = [
    "sparc-muscle-configurator",
    "sparc-muscle-round-configurator",
    "sparc-driver-configurator",
    "sparc-heritage-configurator",
    "sparc-classic-3100-configurator",
    "sparc-classic-squarebody-configurator",
    "sparc-garage-configurator"
  ];

  var PRICE_LABEL =
    "CONFIGURED PRICE";

  var PRODUCTION_LABEL =
    "EST. PRODUCTION";

  var panel = null;
  var priceMetric = null;
  var productionMetric = null;

  var lastStablePrice = "";
  var lastProduction = "";

  var initialized = false;
  var suppressInitialPriceUntil = 0;

  var observer = null;
  var startupTimer = null;
  var updateTimer = null;

  var priceHold = null;
  var priceAnimation = null;

  function now() {
    return (
      window.performance &&
      typeof window.performance.now === "function"
        ? window.performance.now()
        : Date.now()
    );
  }

  function clean(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function visible(node) {
    if (!node) return false;

    var rect =
      node.getBoundingClientRect();

    var style =
      window.getComputedStyle(node);

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      style.display !== "none" &&
      style.visibility !== "hidden"
    );
  }

  function activePanel() {
    for (
      var i = 0;
      i < PANEL_IDS.length;
      i++
    ) {
      var candidate =
        document.getElementById(
          PANEL_IDS[i]
        );

      if (
        candidate &&
        visible(candidate)
      ) {
        return candidate;
      }
    }

    return null;
  }

  function exactTextElement(
    root,
    wanted
  ) {
    var all =
      Array.prototype.slice.call(
        root.querySelectorAll("*")
      );

    return all.find(
      function (node) {
        return (
          node.children.length === 0 &&
          clean(
            node.textContent
          ).toUpperCase() ===
          wanted
        );
      }
    ) || null;
  }

  function looksLikePrice(text) {
    return (
      /^\$?\s*[\d,]+(?:\.\d{2})?$/.test(
        clean(text)
      )
    );
  }

  function looksLikeProduction(text) {
    var value =
      clean(text).toUpperCase();

    return (
      /\d/.test(value) &&
      (
        value.indexOf("DAY") !== -1 ||
        value.indexOf("WK") !== -1 ||
        value.indexOf("WEEK") !== -1
      )
    );
  }

  function smallestValueElement(
    card,
    label,
    test
  ) {
    if (!card) return null;

    var nodes =
      Array.prototype.slice.call(
        card.querySelectorAll("*")
      ).filter(
        function (node) {
          if (
            node.children.length !== 0
          ) {
            return false;
          }

          var text =
            clean(
              node.textContent
            );

          if (
            !text ||
            text.toUpperCase() ===
              label
          ) {
            return false;
          }

          return test(
            text
          );
        }
      );

    if (!nodes.length) {
      return null;
    }

    nodes.sort(
      function (a, b) {
        return (
          clean(
            a.textContent
          ).length -
          clean(
            b.textContent
          ).length
        );
      }
    );

    return nodes[0];
  }

  function metricFromLabel(
    root,
    label,
    test
  ) {
    var labelNode =
      exactTextElement(
        root,
        label
      );

    if (!labelNode) {
      return null;
    }

    var node =
      labelNode.parentElement;

    var depth = 0;

    while (
      node &&
      node !== root &&
      depth < 5
    ) {
      var value =
        smallestValueElement(
          node,
          label,
          test
        );

      if (value) {
        return {
          label: labelNode,
          card: node,
          value: value
        };
      }

      node =
        node.parentElement;

      depth += 1;
    }

    return null;
  }

  function findMetrics() {
    if (!panel) return false;

    priceMetric =
      metricFromLabel(
        panel,
        PRICE_LABEL,
        looksLikePrice
      );

    productionMetric =
      metricFromLabel(
        panel,
        PRODUCTION_LABEL,
        looksLikeProduction
      );

    return !!(
      priceMetric ||
      productionMetric
    );
  }

  function rawPrice() {
    if (
      !priceMetric ||
      !priceMetric.value
    ) {
      return "";
    }

    return clean(
      priceMetric.value.textContent
    );
  }

  function alignmentToFlex(
    textAlign
  ) {
    var align =
      String(
        textAlign || ""
      ).toLowerCase();

    if (
      align === "right" ||
      align === "end"
    ) {
      return "flex-end";
    }

    if (
      align === "center"
    ) {
      return "center";
    }

    return "flex-start";
  }

  function ensureCardPositioning(
    card
  ) {
    if (!card) return;

    var computed =
      window.getComputedStyle(
        card
      );

    if (
      computed.position ===
      "static"
    ) {
      card.dataset.sparcMetricPriorPosition =
        card.style.position || "";

      card.style.setProperty(
        "position",
        "relative",
        "important"
      );
    }
  }

  function restoreCardPositioning(
    card
  ) {
    if (
      !card ||
      !card.hasAttribute(
        "data-sparc-metric-prior-position"
      )
    ) {
      return;
    }

    var prior =
      card.dataset.sparcMetricPriorPosition;

    if (prior) {
      card.style.position =
        prior;
    } else {
      card.style.removeProperty(
        "position"
      );
    }

    card.removeAttribute(
      "data-sparc-metric-prior-position"
    );
  }

  function layerGeometry() {
    if (
      !priceMetric ||
      !priceMetric.card ||
      !priceMetric.value
    ) {
      return null;
    }

    var card =
      priceMetric.card;

    var value =
      priceMetric.value;

    var cardRect =
      card.getBoundingClientRect();

    var valueRect =
      value.getBoundingClientRect();

    var computed =
      window.getComputedStyle(
        value
      );

    /*
      Extra vertical room is deliberate. The prior implementation clipped
      directly to valueRect.height; this aperture adds 6px above and below.
    */
    var padY = 6;

    var left =
      valueRect.left -
      cardRect.left;

    var top =
      valueRect.top -
      cardRect.top -
      padY;

    /*
      Give the register extra horizontal room for prices that gain digits
      ($875 -> $1,450) without affecting the actual layout.
    */
    var maxAvailable =
      Math.max(
        valueRect.width,
        cardRect.width -
        left -
        3
      );

    return {
      card: card,
      value: value,

      left:
        left,

      top:
        top,

      width:
        maxAvailable,

      height:
        valueRect.height +
        padY * 2,

      padY:
        padY,

      fontFamily:
        computed.fontFamily,

      fontSize:
        computed.fontSize,

      fontWeight:
        computed.fontWeight,

      fontStyle:
        computed.fontStyle,

      lineHeight:
        computed.lineHeight,

      letterSpacing:
        computed.letterSpacing,

      color:
        computed.color,

      justify:
        alignmentToFlex(
          computed.textAlign
        )
    };
  }

  function buildPriceLayer(
    oldText
  ) {
    var geo =
      layerGeometry();

    if (!geo) {
      return null;
    }

    ensureCardPositioning(
      geo.card
    );

    var existing =
      geo.card.querySelector(
        ":scope > .sparc-price-motion-layer"
      );

    if (existing) {
      existing.remove();
    }

    var layer =
      document.createElement(
        "span"
      );

    layer.className =
      "sparc-price-motion-layer is-holding";

    layer.setAttribute(
      "aria-hidden",
      "true"
    );

    layer.style.setProperty(
      "--sparc-price-layer-left",
      geo.left + "px"
    );

    layer.style.setProperty(
      "--sparc-price-layer-top",
      geo.top + "px"
    );

    layer.style.setProperty(
      "--sparc-price-layer-width",
      geo.width + "px"
    );

    layer.style.setProperty(
      "--sparc-price-layer-height",
      geo.height + "px"
    );

    layer.style.setProperty(
      "--sparc-price-layer-pad-y",
      geo.padY + "px"
    );

    layer.style.setProperty(
      "--sparc-price-justify",
      geo.justify
    );

    layer.style.fontFamily =
      geo.fontFamily;

    layer.style.fontSize =
      geo.fontSize;

    layer.style.fontWeight =
      geo.fontWeight;

    layer.style.fontStyle =
      geo.fontStyle;

    layer.style.lineHeight =
      geo.lineHeight;

    layer.style.letterSpacing =
      geo.letterSpacing;

    layer.style.color =
      geo.color;

    layer.innerHTML =
      '<span class="sparc-price-motion-window">' +
        '<span class="sparc-price-motion-line sparc-price-motion-line--old"></span>' +
        '<span class="sparc-price-motion-line sparc-price-motion-line--new"></span>' +
        '<span class="sparc-price-motion-seam"></span>' +
        '<span class="sparc-price-motion-glint"></span>' +
      '</span>';

    layer.querySelector(
      ".sparc-price-motion-line--old"
    ).textContent =
      oldText;

    geo.card.appendChild(
      layer
    );

    /*
      Hide only the pixels of the real value. Its layout remains untouched.
    */
    geo.value.classList.add(
      "sparc-price-source-hidden"
    );

    return {
      layer: layer,
      geo: geo
    };
  }

  function destroyPriceLayer() {
    if (
      priceHold &&
      priceHold.settleTimer
    ) {
      window.clearTimeout(
        priceHold.settleTimer
      );
    }

    if (
      priceAnimation &&
      priceAnimation.finishTimer
    ) {
      window.clearTimeout(
        priceAnimation.finishTimer
      );
    }

    var layer =
      priceMetric &&
      priceMetric.card
        ? priceMetric.card.querySelector(
            ":scope > .sparc-price-motion-layer"
          )
        : null;

    if (layer) {
      layer.remove();
    }

    if (
      priceMetric &&
      priceMetric.value
    ) {
      priceMetric.value.classList.remove(
        "sparc-price-source-hidden"
      );

      priceMetric.value.classList.remove(
        "sparc-price-source-handoff-ready"
      );

      priceMetric.value.classList.remove(
        "sparc-price-source-handoff-in"
      );
    }

    if (
      priceMetric &&
      priceMetric.card
    ) {
      restoreCardPositioning(
        priceMetric.card
      );
    }

    priceHold = null;
    priceAnimation = null;
  }

  function finishPriceAnimation(
    finalText
  ) {
    if (
      !priceAnimation ||
      !priceMetric ||
      !priceMetric.value ||
      !priceMetric.card
    ) {
      return;
    }

    var expected =
      finalText ||
      priceAnimation.finalText;

    var value =
      priceMetric.value;

    var card =
      priceMetric.card;

    var layer =
      card.querySelector(
        ":scope > .sparc-price-motion-layer"
      );

    if (!layer) {
      destroyPriceLayer();
      return;
    }

    /*
      HANDOFF PHASE
      ----------------
      The mechanical motion has already finished and the overlay is now
      sitting perfectly still on the final price.

      Instead of deleting it in one frame, prepare the true static source
      underneath and crossfade the two renderings. This hides any tiny
      baseline/rasterization difference between overlay text and native text.
    */
    value.classList.add(
      "sparc-price-source-handoff-ready"
    );

    layer.classList.add(
      "is-settled"
    );

    /*
      Force the settled final overlay + hidden static source to paint first.
    */
    void value.offsetWidth;

    window.requestAnimationFrame(
      function () {
        /*
          Reveal the native price while fading the overlay away.
        */
        value.classList.remove(
          "sparc-price-source-hidden"
        );

        value.classList.add(
          "sparc-price-source-handoff-in"
        );

        layer.classList.add(
          "is-handing-off"
        );

        window.setTimeout(
          function () {
            var current =
              rawPrice();

            /*
              Remove the temporary animation layer only AFTER the crossfade.
            */
            if (
              layer &&
              layer.parentNode
            ) {
              layer.parentNode.removeChild(
                layer
              );
            }

            value.classList.remove(
              "sparc-price-source-handoff-ready"
            );

            value.classList.remove(
              "sparc-price-source-handoff-in"
            );

            restoreCardPositioning(
              card
            );

            priceHold = null;
            priceAnimation = null;

            if (
              current &&
              looksLikePrice(
                current
              )
            ) {
              lastStablePrice =
                current;
            } else if (
              expected
            ) {
              lastStablePrice =
                expected;
            }

            /*
              If pricing changed again while the reel/handoff was running,
              treat that new value as a new transition.
            */
            window.setTimeout(
              function () {
                var after =
                  rawPrice();

                if (
                  after &&
                  looksLikePrice(
                    after
                  ) &&
                  after !==
                    lastStablePrice
                ) {
                  beginPriceHoldFromMutation(
                    after
                  );
                }
              },
              40
            );
          },
          190
        );
      }
    );
  }

  function runPriceAnimation(
    finalText
  ) {
    if (
      !priceHold ||
      !priceHold.layerInfo ||
      !finalText
    ) {
      destroyPriceLayer();
      return;
    }

    var oldText =
      priceHold.oldText;

    if (
      finalText === oldText
    ) {
      destroyPriceLayer();
      lastStablePrice =
        finalText;
      return;
    }

    var layer =
      priceHold.layerInfo.layer;

    var newLine =
      layer.querySelector(
        ".sparc-price-motion-line--new"
      );

    newLine.textContent =
      finalText;

    layer.classList.remove(
      "is-holding"
    );

    void layer.offsetWidth;

    layer.classList.add(
      "is-rolling"
    );

    lastStablePrice =
      finalText;

    priceAnimation = {
      finalText:
        finalText,

      finishTimer:
        window.setTimeout(
          function () {
            finishPriceAnimation(
              finalText
            );
          },
          1390
        )
    };

    priceHold = null;
  }

  function settlePriceHold() {
    if (!priceHold) return;

    var finalText =
      rawPrice();

    if (
      !finalText ||
      !looksLikePrice(
        finalText
      )
    ) {
      priceHold.settleTimer =
        window.setTimeout(
          settlePriceHold,
          100
        );
      return;
    }

    /*
      Require the same value to survive one settle window. Every new DOM
      mutation resets the timer, so intermediate Hulk prices never animate.
    */
    runPriceAnimation(
      finalText
    );
  }

  function schedulePriceSettle() {
    if (!priceHold) return;

    window.clearTimeout(
      priceHold.settleTimer
    );

    priceHold.settleTimer =
      window.setTimeout(
        settlePriceHold,
        210
      );
  }

  function beginPriceHoldFromMutation(
    newText
  ) {
    if (
      !initialized ||
      now() <
        suppressInitialPriceUntil
    ) {
      if (
        newText &&
        looksLikePrice(
          newText
        )
      ) {
        lastStablePrice =
          newText;
      }

      return;
    }

    if (
      priceAnimation
    ) {
      /*
        Let the current animation finish; its completion callback checks
        whether another price appeared meanwhile.
      */
      return;
    }

    if (
      !lastStablePrice ||
      !looksLikePrice(
        lastStablePrice
      )
    ) {
      lastStablePrice =
        newText;
      return;
    }

    if (!priceHold) {
      var layerInfo =
        buildPriceLayer(
          lastStablePrice
        );

      if (!layerInfo) {
        lastStablePrice =
          newText;
        return;
      }

      priceHold = {
        oldText:
          lastStablePrice,

        layerInfo:
          layerInfo,

        settleTimer:
          null
      };
    }

    schedulePriceSettle();
  }

  function handlePriceMutation() {
    if (
      !priceMetric ||
      !priceMetric.value
    ) {
      return;
    }

    var current =
      rawPrice();

    if (
      !current ||
      !looksLikePrice(
        current
      )
    ) {
      return;
    }

    if (
      priceAnimation
    ) {
      return;
    }

    if (
      priceHold
    ) {
      schedulePriceSettle();
      return;
    }

    if (
      current !==
      lastStablePrice
    ) {
      beginPriceHoldFromMutation(
        current
      );
    }
  }

  function productionAttention(
    metric
  ) {
    if (
      !metric ||
      !metric.card ||
      !metric.value
    ) {
      return;
    }

    var card =
      metric.card;

    var value =
      metric.value;

    card.classList.remove(
      "sparc-production-change-active"
    );

    value.classList.remove(
      "sparc-production-value-active"
    );

    void card.offsetWidth;

    card.classList.add(
      "sparc-production-change-active"
    );

    value.classList.add(
      "sparc-production-value-active"
    );

    window.setTimeout(
      function () {
        card.classList.remove(
          "sparc-production-change-active"
        );

        value.classList.remove(
          "sparc-production-value-active"
        );
      },
      2800
    );
  }

  function updateProduction() {
    if (
      !productionMetric ||
      !productionMetric.value
    ) {
      return;
    }

    var current =
      clean(
        productionMetric.value.textContent
      );

    if (
      !current ||
      !looksLikeProduction(
        current
      )
    ) {
      return;
    }

    if (!initialized) {
      lastProduction =
        current;
      return;
    }

    if (
      lastProduction &&
      current !==
        lastProduction
    ) {
      productionAttention(
        productionMetric
      );
    }

    lastProduction =
      current;
  }

  function scheduleUpdate() {
    window.clearTimeout(
      updateTimer
    );

    updateTimer =
      window.setTimeout(
        function () {
          updateProduction();
        },
        70
      );
  }

  function mutationTouchesPrice(
    record
  ) {
    if (
      !priceMetric ||
      !priceMetric.value
    ) {
      return false;
    }

    var target =
      record.target;

    if (
      target &&
      target.nodeType === 3
    ) {
      target =
        target.parentElement;
    }

    if (!target) {
      return false;
    }

    return (
      target ===
        priceMetric.value ||
      (
        priceMetric.value.contains &&
        priceMetric.value.contains(
          target
        )
      )
    );
  }

  function mutationIsOurLayer(
    record
  ) {
    var target =
      record.target;

    if (
      target &&
      target.nodeType === 3
    ) {
      target =
        target.parentElement;
    }

    return !!(
      target &&
      target.closest &&
      target.closest(
        ".sparc-price-motion-layer"
      )
    );
  }

  function installObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    observer =
      new MutationObserver(
        function (records) {
          var priceTouched =
            false;

          var otherRelevant =
            false;

          records.forEach(
            function (record) {
              if (
                mutationIsOurLayer(
                  record
                )
              ) {
                return;
              }

              if (
                mutationTouchesPrice(
                  record
                )
              ) {
                priceTouched =
                  true;
              } else {
                otherRelevant =
                  true;
              }
            }
          );

          /*
            MutationObserver callbacks run before browser paint. This is
            the key to covering the first changed price with the old stable
            value before the customer sees an intermediate Hulk price.
          */
          if (priceTouched) {
            handlePriceMutation();
          }

          if (otherRelevant) {
            scheduleUpdate();
          }

          if (
            priceHold &&
            priceTouched
          ) {
            schedulePriceSettle();
          }
        }
      );

    observer.observe(
      panel,
      {
        subtree: true,
        childList: true,
        characterData: true
      }
    );
  }

  function refreshMetricRefs() {
    if (
      priceMetric &&
      !document.body.contains(
        priceMetric.value
      )
    ) {
      destroyPriceLayer();
      findMetrics();

      lastStablePrice =
        rawPrice();
    }

    if (
      productionMetric &&
      !document.body.contains(
        productionMetric.value
      )
    ) {
      findMetrics();

      lastProduction =
        productionMetric
          ? clean(
              productionMetric.value.textContent
            )
          : "";
    }
  }

  function attach() {
    var found =
      activePanel();

    if (!found) {
      return false;
    }

    panel =
      found;

    if (!findMetrics()) {
      panel = null;
      return false;
    }

    lastStablePrice =
      rawPrice();

    lastProduction =
      productionMetric
        ? clean(
            productionMetric.value.textContent
          )
        : "";

    initialized =
      true;

    /*
      Suppress startup pricing chatter; the loading screen already hides it.
    */
    suppressInitialPriceUntil =
      now() + 650;

    installObserver();

    console.info(
      "[SPARC METRIC MOTION V1.5] Active.",
      {
        panel:
          panel.id,

        price:
          !!priceMetric,

        production:
          !!productionMetric
      }
    );

    return true;
  }

  function start() {
    var attempts = 0;

    startupTimer =
      window.setInterval(
        function () {
          attempts += 1;

          if (
            attach() ||
            attempts >= 80
          ) {
            window.clearInterval(
              startupTimer
            );

            startupTimer =
              null;
          }
        },
        250
      );

    /*
      Defensive ref refresh if a configurator rebuilds its header.
    */
    window.setInterval(
      refreshMetricRefs,
      750
    );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();
